var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrophone02 = function SvgMicrophone02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.25 21v-3.546q-2.475-.283-4.112-2.123T5.5 11H7q0 2.075 1.463 3.537Q9.926 16 12 16q2.075 0 3.537-1.463Q17 13.075 17 11h1.5q0 2.49-1.637 4.33-1.638 1.841-4.113 2.124V21z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.5 11V6a1.5 1.5 0 0 0-3 0v5a1.5 1.5 0 0 0 1.5 1.5V14a3 3 0 0 1-2.996-2.846L9 11V6a3 3 0 1 1 6 0v5a3 3 0 0 1-3 3v-1.5a1.5 1.5 0 0 0 1.5-1.5"
  })));
};
export default SvgMicrophone02;